import React, { useEffect
  // , useState 
} 
from "react";

import { Toast, ToastBody, ToastHeader } from "reactstrap";

let timer;
const ToastHandler = ({
  duration = 1000,
  message,
  title,
  autoClose = true,
  setOpen,
  open,
}) => {
  useEffect(() => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      setOpen(false);
    }, duration);
    return () => {
      clearTimeout(timer);
    };
  }, [open, duration, setOpen]);
  return (
    <div
      className="position-fixed bottom-0 start-50 translate-middle p-3"
      style={{ zIndex: "1005" }}
    >
      <Toast isOpen={open}>
        <ToastHeader toggle={() => setOpen(false)}>
          {/* <img src={logo} alt="" className="me-2" height="18" /> */}
          {title}
        </ToastHeader>
        <ToastBody color="primary">{message}</ToastBody>
      </Toast>
    </div>
  );
};

export default ToastHandler;
